import React, { useEffect } from "react"
import { Heading } from "frontend/components/text"
import { Card } from "frontend/components/layout"
import { Form } from "frontend/components/forms"
import { ProgressCircle } from "frontend/components/progress"
import { Button } from "frontend/components/interaction"
import t from "frontend/utils/translations"
import DiscoverabilityScore from "./DiscoverabilityScore"
import EmbeddedSlideshow from "./EmbeddedSlideshow"

import styles from "./UploadForm.module.css"
import { bytesToMB } from "frontend/utils/upload"
import { getFields, renderFields } from "./util/fields"
import { logUploadFlowEvent } from "../../utils"

const unloadHandler = function (event) {
  event.preventDefault()
  event.returnValue = "You have unsaved changes on your upload"
}

const UploadForm = (props) => {
  const { file, uploadFile, embedUrl, onDelete, progress, progressMessage, onSubmit, slideshowType } = props
  const sizeInMB = bytesToMB(file.size)

  useEffect(() => {
    uploadFile()

    window.addEventListener("beforeunload", unloadHandler)

    return () => {
      window.removeEventListener("beforeunload", unloadHandler)
    }
  }, [])

  const handleDelete = (e) => {
    e.preventDefault()

    logUploadFlowEvent("file_deleting")

    const shouldProceed = confirm("You have unsaved changes on your upload")
    if (shouldProceed) {
      onDelete(file)

      logUploadFlowEvent("upload_deleted")
      logUploadFlowEvent("cancelled")
    }
  }

  const hasBeenUploaded = Boolean(embedUrl)

  return (
    <Card className={styles.container}>
      <div className={styles.formHeader}>
        {hasBeenUploaded ? (
          <div className={styles.iframeWrapper}>
            <EmbeddedSlideshow embedUrl={embedUrl} />
          </div>
        ) : (
          <div className={styles.loadingContainer}>
            <ProgressCircle percent={progress} backgroundColor={"#F5FCFF"} />
          </div>
        )}
        <div className={styles.progressDetailsContainer}>
          <Heading size={4} className={styles.filename}>
            {file.filename}
          </Heading>
          {hasBeenUploaded ? (
            <Heading size={6} className={styles.uploadProgress}>
              {sizeInMB} Mb
            </Heading>
          ) : (
            <Heading size={6} className={styles.uploadProgress}>
              {progressMessage}
            </Heading>
          )}
        </div>
      </div>
      <hr className={styles.divider} />
      <Form
        onSubmit={onSubmit}
        fields={getFields(file, slideshowType)}
        renderFields={renderFields}
        renderFooter={({ values, onSubmit, isSubmitting }) => {
          return (
            <div className={styles.footer}>
              <DiscoverabilityScore className={styles.discoverabilityScore} values={values} />
              <div className={styles.buttonContainer}>
                <Button
                  label={t("upload.form.buttons.delete")}
                  type="secondary"
                  disabled={!file.isUploaded}
                  onClick={handleDelete}
                />

                <Button
                  label={t("upload.form.buttons.publish")}
                  type="primary"
                  disabled={isSubmitting || !file.isUploaded}
                  onClick={onSubmit}
                  testId="publish"
                />
              </div>
            </div>
          )
        }}
      />
    </Card>
  )
}

export default UploadForm
